import React, { useState } from 'react';
import { AccordionContainer } from './CustomAccordion.styled';
import { SegmentSubTitle } from '../../../../SegmentSettings/SegmentSettings.styled';
import TextView from '../../../../TextView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ContentEditable from 'react-contenteditable';

const CustomAccordion = ({
  header,
  expanded,
  onToggle,
  children,
  dropDownRightIcon,
  borderColor,
  borderWidth,
  borderRadius,
  headerBgColor,
  isHeaderHtml = false,
  dropShadowColor,
  headerOpacity,
}) => {
  const handleToggle = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    if (onToggle) {
      onToggle();
    }
  };

  const getIcon = () => {
    if (dropDownRightIcon === 0) {
      return expanded ? <KeyboardArrowUpIcon style={{color:'white'}}/> : <ExpandMoreIcon style={{color:'white'}}/>;
    }
    return expanded ? <RemoveIcon style={{color:'white'}}/> : <AddIcon style={{color:'white'}}/>;
  };

  // console.log(isHeaderHtml,"isHeaderHtmlisHeaderHtmlisHeaderHtmlisHeaderHtml")
  return (
    <AccordionContainer
      borderColor={borderColor}
      borderWidth={borderWidth}
      borderRadius={borderRadius}
      headerBgColor={headerBgColor}
      dropShadowColor={dropShadowColor}
      headerOpacity={headerOpacity}
      className={expanded ? 'expanded' : ''}
    >
      <div 
        className="accordion-summary" 
        onClick={handleToggle}
        onMouseDown={(e) => e.stopPropagation()} // Prevent drag events from interfering
      >
        {isHeaderHtml ? (
          <>
            <ContentEditable html={header} className="textContentEditable" disabled style={{color:'white'}}/>
          </>
        ) : (
          <TextView style={{color:'white'}}>{header}</TextView>
        )}
        {getIcon()}
      </div>
      {expanded ? <div>{children}</div> : null}
    </AccordionContainer>
  );
};

export default CustomAccordion;
